import React from 'react';
import { Row, Col, Card, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const OrdersOverview = ({ data }) => {
  const { salesOrders, purchaseOrders, productionRequests } = data;

  // Calculate statistics
  const soStats = calculateOrderStats(salesOrders, 'status');
  const poStats = calculateOrderStats(purchaseOrders, 'status');
  const prStats = calculateOrderStats(productionRequests, 'status');

  return (
    <div>
      <Row className="g-3 mb-4">
        <Col md={4}>
          <StatCard
            title="Sales Orders"
            total={salesOrders.length}
            stats={soStats}
            link="/sales-orders"
            color="primary"
          />
        </Col>
        <Col md={4}>
          <StatCard
            title="Purchase Orders"
            total={purchaseOrders.length}
            stats={poStats}
            link="/purchase-orders"
            color="success"
          />
        </Col>
        <Col md={4}>
          <StatCard
            title="Production Requests"
            total={productionRequests.length}
            stats={prStats}
            link="/production-requests"
            color="warning"
          />
        </Col>
      </Row>

      <Row className="g-3">
        <Col lg={6}>
          <Card>
            <Card.Header>
              <h6 className="mb-0">Recent Sales Orders</h6>
            </Card.Header>
            <Card.Body className="p-0">
              <RecentOrdersList orders={salesOrders.slice(0, 5)} type="sales" />
            </Card.Body>
          </Card>
        </Col>
        <Col lg={6}>
          <Card>
            <Card.Header>
              <h6 className="mb-0">Recent Purchase Orders</h6>
            </Card.Header>
            <Card.Body className="p-0">
              <RecentOrdersList orders={purchaseOrders.slice(0, 5)} type="purchase" />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

const StatCard = ({ title, total, stats, link, color }) => (
  <Card className="h-100">
    <Card.Body className="d-flex flex-column">
      <div className="d-flex justify-content-between align-items-start ">
        <div>
          <h6 className="text-muted mb-1">{title}</h6>
          <h3 className="mb-0">{total}</h3>
        </div>
      </div>
      
      <div className="mt-3">
        {Object.entries(stats).map(([status, count]) => (
          <div key={status} className="d-flex justify-content-between align-items-center mb-2">
            <span className="small">{status}</span>
            <Badge bg={getStatusColor(status)} className="ms-2">
              {count}
            </Badge>
          </div>
        ))}
      </div>
      <div className='text-end mt-3 flex-grow-1 align-content-end'>
        <Link to={link} className={`btn btn-sm btn-outline-${color}`}>
          View All
        </Link>
      </div>
      
      {/* {total > 0 && (
        <div className="mt-3">
          <ProgressBar className="progress-sm">
            {Object.entries(stats).map(([status, count]) => (
              <ProgressBar
                key={status}
                variant={getStatusColor(status)}
                now={(count / total) * 100}
                label={`${Math.round((count / total) * 100)}%`}
              />
            ))}
          </ProgressBar>
        </div>
      )} */}
    </Card.Body>
  </Card>
);

const RecentOrdersList = ({ orders, type }) => {
  if (!orders || orders.length === 0) {
    return (
      <div className="p-3 text-center text-muted">
        <small>No recent orders</small>
      </div>
    );
  }

  return (
    <div className="list-group list-group-flush">
      {orders.map((order) => (
        <div key={order._id} className="list-group-item border-0 py-2">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <Link 
                to={`/${type === 'sales' ? 'sales' : 'purchase'}-orders/${order._id}`}
                className="fw-medium text-decoration-none"
              >
                {order.orderNumber || `Order #${order._id.slice(-6)}`}
              </Link>
              <div className="small text-muted">
                {type === 'sales' ? order.buyer?.business_name : order.vendorId?.business_name}
              </div>
            </div>
            <div className="text-end">
              <Badge bg={getStatusColor(order.status)} className="mb-1">
                {order.status}
              </Badge>
              <div className="small text-muted">
                {new Date(order.orderDate || order.createdAt).toLocaleDateString('en-IN')}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const calculateOrderStats = (orders, statusField) => {
  const stats = {};
  orders.forEach(order => {
    const status = order[statusField] || 'Unknown';
    stats[status] = (stats[status] || 0) + 1;
  });
  return stats;
};

const getStatusColor = (status) => {
  const statusColors = {
    'Pending': 'warning',
    'PENDING': 'warning',
    'Created': 'info',
    'Confirmed': 'primary',
    'APPROVED': 'primary',
    'In Progress': 'primary',
    'Partially Delivered': 'secondary',
    'Delivered': 'success',
    'Completed': 'success',
    'Closed': 'success',
    'Cancelled': 'danger',
    'Rejected': 'danger',
    'Loaded': 'secondary',
    'Dispatched': 'info',
    'Finalized': 'secondary'
  };
  return statusColors[status] || 'light';
};

export default OrdersOverview;